<template>
  <Layout>
    <!-- start page title -->
    <PageHeader :title="title" :items="items" />
    <!-- end page title -->

    <div class="row">
<!--      <div class="col-xl-3">-->
<!--        <BranchStatsPanel />-->
<!--      </div>-->
      <!-- end col -->
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Cash Withdrawal Checkers Queue</h4>
            <!-- Supposed Form -->
            <div class="form-body">
              <CashWithdrawalCheckersQueueTable />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>

<script>
/**
 * Update Branch Status
 */


import Layout from "../../router/layouts/main";
import PageHeader from "../../components/AppComponents/page-header";

export default {
  page: {
    title: "Cash Withdrawal Checkers Queue",
    meta: [{ name: "Cash Withdrawal Checkers Queue", content: window.__env.app.description }]
  },
  components: {
    Layout,
    PageHeader
  },
  data() {
    return {
      title: "Cash Withdrawal Checkers Queue",
      items: [
        {
          text: "Cash Withdrawal",
          href: "/"
        },
        {
          text: "Cash Withdrawal Checkers Queue",
          active: true
        }
      ]
    };
  }
};
</script>
